import { render, staticRenderFns } from "./candidate-wizard.vue?vue&type=template&id=97b8ba2a&"
import script from "./candidate-wizard.vue?vue&type=script&lang=js&"
export * from "./candidate-wizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports